export default __webpack_public_path__ + "static/media/033-cold.b3d53074.svg";